import Management from 'Management'
import React from 'react'

export default function Students() {
    const columns = [
        { title: "Họ", dataIndex: "user", key: "last_name", render: item => item.last_name },
        { title: "Tên đệm và tên", dataIndex: "user", key: "first_name", render: item => item.first_name },
    ]

    const layout = [
        [{ label: "Họ", name: "user__last_name", type: "input", rules: [{ required: true }] }],
        [{ label: "Tên đệm và tên", name: "user__first_name", type: "input", rules: [{ required: true }] }],
        [{ label: "Mã học sinh", name: "student_number", type: "input", rules: [{ required: true }] }],
    ]

    return <Management
        layout={layout}
        apiPath="/student-infos/"
        itemName="học sinh"
        columns={columns}
    />
}
